import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Box from '@material-ui/core/Box';
import { ITheme } from '../../../style/theme';
import { colors } from '../../../style/colors';
import MenuDesktop from './MenuDesktop';

const useStyles = makeStyles((theme: ITheme) => ({
  root: {
    display: 'table',
    position: 'fixed',
    top: 56,
    left: 0,
    width: 84,
    height: '90%',
    paddingLeft: theme.spacing(2),
    backgroundColor: colors.gainsboro,
  },
  logo: {
    width: 129,
    height: 18,
  },
}));

const Drawer = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Box display="table-row">
        <Box display="table-cell" height="100%">
          <MenuDesktop />
        </Box>
      </Box>
    </div>
  );
};

export default Drawer;
